import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/contact.css';
import { FaLocationArrow, FaPhoneAlt, FaEnvelope, FaBars, FaArrowRight} from 'react-icons/fa';
import {MapContainer, Marker, TileLayer, Popup} from 'react-leaflet';
import "leaflet/dist/leaflet.css";



const Contact = () => {
        const [open, setOpen] = useState(false);
        const [inputs, setInputs] = useState({
            name: "",
            email: "",
            message: ""
        });

        const { name, email, message } = inputs;
        const onChange = e =>{
            setInputs ({ ...inputs, [e.target.name]: e.target.value });
            
        }
        const onFormSubmit = async (e) => {
            e.preventDefault();
            try {
                const body = {name, email, message }
                const response = await fetch(
                    "http://localhost:5000/send/message",
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(body)
                    }
                );
                console.log(response)
            } catch (err) {
                console.error(err.message);
            }
        }
    const position = [-1.286389, 36.817223]
    const mapstyle={
        height:'50vh',
        width:'100%'
    }
    return(
        <div className="">
            <nav>
                <div className="logo">fm</div>
                <ul className="nav-links" style={{ transform: open ? "translateX(0px)" : "" }}>
                    <li><Link className="nav-item" to="/">About</Link></li>
                    <li><Link className="nav-item" to="/" >Services</Link></li>
                    <li><Link className="nav-item" to="/projects">Projects</Link></li>
                    <li><Link className="nav-item" to="/">Skills</Link></li>
                    <li><Link className="nav-item" to='/' >Mentors</Link></li>
                    <li><Link className="nav-item" to="/blog">Blog</Link></li>
                    <li><Link className="nav-item" to="/contact">Contact</Link></li>
                </ul>
                <FaBars onClick={() => setOpen(!open)} className="fa-bars" color="#5cb85c" />
            </nav>
            <section>
                <div className='container' id="location-details">
                    <h1 className="display-3 font-800 text-left pb-4">Feel free to call me, send a message or write an email.</h1>
                    <div className="contact-details">
                        <div className="contact-form">
                            <div className="row justify-content-space-around">
                            <div className="col-sm-8">
                                <MapContainer center={position} zoom={13} scrollWheelZoom={true} style={mapstyle}>
                                    <TileLayer
                                        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                            url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}.png"
                                    />
                                     <Marker position={[-1.286389, 36.817223]}>
                                        <Popup>
                                         Nairobi. <br/> Kenya.
                                        </Popup>
                                    </Marker>
                                </MapContainer>   
                            </div>
                            <div className="col-sm-4">
                                    <a href='tel:+254726219092' ><FaPhoneAlt className="i"/><span className="form-info">+254
                                        726219092</span><br/></a>
                                    <a href="#"><FaLocationArrow className="i" /><span className="form-info">Nairobi,
                                        KENYA</span><br/></a>
                                    <a href='#'><FaEnvelope className="i"/><span className="form-info">fmuchembi@gmail.com</span><br/></a>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        </section>
            <section className="bg-light page-section">
                <div className="container">
                <h1 className="display-3 font-800 text-left pb-4" id="contact-h1"> You can also send a message, lets keep in touch</h1>
                <div id="error_message"></div>
                <form onSubmit={onFormSubmit} id="form" className="form-section">
                    <div>
                        <label className="form-label">Your name:</label>
                        <input type="text" name="name" id="name" required value={name} onChange={e => onChange(e)}/>
                    </div>
                    <div id="theName">
                        <label className="form-label">Your Email:</label>
                            <input type="email" name="email" id="email" required value={email} onChange={e => onChange(e)}/>
                    </div>
                    <div>
                        <textarea name='message' id='message' placeholder="Type your message here"  value={message} onChange={e => onChange(e)}></textarea>
                    </div>
                    <div>
                        <button className="btn btn-success">submit</button>
                    </div>
                </form>
            </div>
        </section>
        <section>
            <div className="bt-container">
                <div className="green-shadow">
                    <h1 id="h1-bt">Get in touch</h1>
                    <div className='row' id="row-bt">
                            <div className="col-sm" id="bottom_buttons">
                            <button type="button" className="btn btn-success btn-lg">
                                <Link className="bt_link" to="/contact">Reach out to me today</Link></button>
                            <div id="gif">
                                <img src="./images/gif/giphy.gif" width="150" height="150" />
                            </div>
                        </div>
                        <div className="col-sm" id="bottom_buttons">
                            <button type="button" className="btn btn-success btn-lg">Lets build awesome projects together</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
            <section>
                <div className="footer-section">
                    <div className='footer-row'>
                        <div className="row">
                            <div className="col-sm" id="footer-col-sm">
                                <h4>My main goal</h4>
                                <li><a className="">
                                 My main goal is to Intergrate <br /> existing GIS capabilities to <br />applications and solutions in<br /> various companies</a>
                                </li>
                            </div>
                            <div className="col-sm" id="footer-col-sm">
                                <h4>Links</h4>
                                <ul className="list-unstyled">
                                    <li> <FaArrowRight /><a href="#about" className="">About</a></li>
                                    <li> <FaArrowRight /><a href="#resume" className="">Resume</a></li>
                                    <li> <FaArrowRight /><a href="#service" className="">Services</a></li>
                                    <li> <FaArrowRight /><a href="#skills" className="">Skills</a></li>
                                    <li> <FaArrowRight /><a href="#projects" className="">Projects</a></li>
                                    <li> <FaArrowRight /><a href="#mentor" className="">Mentors</a></li>
                                    <li> <FaArrowRight /><a href="#contacts" className="">Contacts</a></li>
                                    <li> <FaArrowRight /><a href="#blog" className="">Blog</a></li>
                                </ul>
                            </div>
                            <div className="col-sm" id="footer-col-sm">
                                <h4 className="">Skills</h4>
                                <ul className="list-unstyled">
                                    <li><FaArrowRight /><a href="#" className="">ReactJS</a></li>
                                    <li><FaArrowRight /><a href="#" className="">NodeJS</a></li>
                                    <li><FaArrowRight /><a href="#" className="">Django</a></li>
                                    <li><FaArrowRight /><a href="#" className="">Web Development</a></li>
                                    <li><FaArrowRight /><a href="#" className="">GIS analysis</a></li>
                                    <li><FaArrowRight /><a href="#" className="">Python</a></li>
                                    <li><FaArrowRight /><a href="#" className="">Remote Sensing</a></li>
                                    <li><FaArrowRight /><a href="#" className="">Postgresql</a></li>
                                </ul>
                            </div>
                            <div className="col-sm" id="footer-col-sm">
                                <h4>Social platforms</h4>
                                <li><a>You can also find me on these social media platforms</a></li>
                                <ul className="list-unstyled" id="list-one">
                                    <li id="icons1"><a href="https://www.linkedin.com/in/faith-muchembi-71b53910b" target="_blank"><span className="fa fa-linkedin" id="the-fa"></span></a></li>
                                    <li id="icons2"><a href="https://github.com/fmuchembi" target="_blank"><span className="fa fa-github" id="the-fa1" ></span></a></li>
                                    <li id="icons3"><a href="https://web.facebook.com/fmuchembi" target="_blank"><span className="fa fa-facebook" id="the-fa2"></span></a></li>
                                    <li id="icons5"><a href="https://twitter.com/muchembif" target="_blank"><span className="fa fa-twitter" id="the-fa4"></span></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="footer-section-2">
                <div className='footer-row2'>
                    <div className="row">
                        <div className="col-md-12 text-center">
                            <p>Copyright &copy; <script>document.write(new Date().getFullYear());</script> Designed and built by Faith Muchembi</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}




export default Contact;